import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const draftEmbeddedPageModalEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-draft-embedded-confluence-page-modal" */ '.'),
	),
	getPreloadProps: () => ({}),
});
